import actionTypes from './actionTypes'
import { AnyAction } from 'redux'
import { IGameSettings } from '../../helpers/data/gameSettings'

const windowResized = (width: number, height: number): IActionWindowResized => {
	return {
		type: actionTypes.APP_WINDOW_RESIZE,
		width,
		height,
	}
}

const initializeApp = (params: any) => {
	return {
		type: actionTypes.APP_INIT,
		params,
	}
}

const gameUpdate = (payload: any) => {
	return {
		type: actionTypes.GAME_UPDATE,
		payload,
	}
}

const gameStart = () => {
	return {
		type: actionTypes.GAME_START,
	}
}

const gameEnd = () => {
	return {
		type: actionTypes.GAME_END,
	}
}

const gameSettings = (settings: IGameSettings): IActionGameSettings => {
	return {
		type: actionTypes.GAME_SETTINGS,
		settings,
	}
}

const splashComplete = () => {
	return {
		type: actionTypes.SPLASH_COMPLETE,
	}
}

const configLoaded = (config: any) => {
	return {
		type: actionTypes.APP_CONFIG_LOADED,
		config,
	}
}

const appConnected = () => {
	return {
		type: actionTypes.APP_CONNECTED,
	}
}

const appLimitReached = () => {
	return {
		type: actionTypes.APP_LIMIT_REACHED,
	}
}

const pingServer = () => {
	return {
		type: actionTypes.APP_PING_SERVER,
	}
}

const skinLoaded = (data: any) => {
	return {
		type: actionTypes.APP_SKIN_LOADED,
		data,
	}
}

const errorCaught = (data: any) => {
	return {
		type: actionTypes.APP_ERROR_CAUGHT,
		data,
	}
}

const hideStudentNamesUpdate = (hideStudentNames: boolean): IActionGameHideStudentNamesUpdate => {
	return {
		type: actionTypes.SESSION_SETTINGS_HIDE_STUDENT_NAMES_UPDATE,
		hideStudentNames,
	}
}

const dispatchFeatureFlags = (featureFlags: any) => {
	return {
		type: actionTypes.FEATURE_FLAGS_GET_SUCCESS,
		featureFlags,
	}
}

const getFeatureFlags = (params: any) => {
	return {
		type: actionTypes.FEATURE_FLAGS_GET,
		params,
	}
}

const studentSubmissionUpdate = (studentSubmission: any) => {
	return {
		type: actionTypes.GAME_STUDENT_SUBMISSION_UPDATE,
		studentSubmission,
	}
}

const moveToNextActivity = () => {
	return {
		type: actionTypes.GAME_MOVE_TO_NEXT_ACTIVITY,
	}
}

const audioUpdate = (volume: number, isMuted: boolean) => {
	return {
		type: actionTypes.AUDIO_UPDATE,
		volume,
		isMuted,
	}
}

const animationsToggleUpdate = (enabled: boolean): IActionAnimationsToggleUpdate => {
	return {
		type: actionTypes.ANIMATIONS_TOGGLE_UPDATE,
		payload: { enabled },
	}
}

export default {
	windowResized,
	initializeApp,
	gameStart,
	gameUpdate,
	gameEnd,
	splashComplete,
	configLoaded,
	appConnected,
	appLimitReached,
	pingServer,
	gameSettings,
	skinLoaded,
	studentSubmissionUpdate,
	errorCaught,
	hideStudentNamesUpdate,
	dispatchFeatureFlags,
	getFeatureFlags,
	moveToNextActivity,
	audioUpdate,
	animationsToggleUpdate,
}

export interface IActionWindowResized extends AnyAction {
	width: number
	height: number
}

export interface IActionGameUpdate extends AnyAction {
	width: number
	height: number
}

export interface IActionGameSettings extends AnyAction {
	settings: IGameSettings
}

export interface IActionGameHideStudentNamesUpdate extends AnyAction {
	hideStudentNames: boolean
}

export interface IActionAnimationsToggleUpdate extends AnyAction {
	payload: { enabled: boolean }
}
